module.exports = __webpack_public_path__ + "img/ic_map_hotel_label_4_stars.dd5582f6.svg";